import { ArrowDownUp, ArrowUpDown, Grid3x3, Star } from 'lucide-react';
import type { TranslationKey } from '@/i18n';
import type { TrainingMode } from '@/types/training';
import type { OrnamentKind } from './Ornament';

export interface ModeConfig {
  to: string;
  titleKey: TranslationKey;
  hintKey: TranslationKey;
  Icon: typeof Grid3x3;
  tone: 'green' | 'blue' | 'violet' | 'orange';
  ornament: OrnamentKind;
}

/**
 * Route, label, colour and icon for each training mode.
 *
 * Kept out of the component file so both `ModeCard` and the pages that need to
 * navigate to a mode can import it without breaking fast refresh.
 */
export const MODE_CONFIG: Record<TrainingMode, ModeConfig> = {
  chordChange: {
    to: '/training/chord-change',
    titleKey: 'modes.chordChange',
    hintKey: 'modes.chordChangeHint',
    Icon: Grid3x3,
    tone: 'green',
    ornament: 'leaves',
  },
  cleanChord: {
    to: '/training/clean-chords',
    titleKey: 'modes.cleanChord',
    hintKey: 'modes.cleanChordHint',
    Icon: Star,
    tone: 'blue',
    ornament: 'notes',
  },
  rhythm: {
    to: '/training/rhythm',
    titleKey: 'modes.rhythm',
    hintKey: 'modes.rhythmHint',
    Icon: ArrowDownUp,
    tone: 'violet',
    ornament: 'drum',
  },
  strumming: {
    to: '/training/strumming',
    titleKey: 'modes.strumming',
    hintKey: 'modes.strummingHint',
    Icon: ArrowUpDown,
    tone: 'orange',
    ornament: 'guitar',
  },
};
